export default __webpack_public_path__ + "static/media/phone-icon.86842fc8.svg";